import Dialog from "./index.vue";

Dialog.install = Vue => Vue.component(Dialog.componentName, Dialog);

export default Dialog;
